import { getterProvider, installable } from 'shared/stores/core/decorators';
import { getPlugin } from 'shared/stores/uScope/plugin-access';

@installable
@getterProvider('VIEWPORT')
export class ViewportState {
  // List of all valid viewports, addressable via imageId. Note these are *not* attached to "state" to prevent
  // Vue from converting all public members to Vue Observables.
  viewportsByImageId = {};

  getters = {
    plugins: ({uScopeApi}) => (pluginName, imageId) => {
      const viewport = imageId ? this.getters.getViewport({imageId}) : this.getters.currentViewport;
      return getPlugin(uScopeApi, viewport, pluginName);
    },
    currentViewport: ({state}) => {
      return this.getters.getViewport({imageId: state('IMAGE').selectedImageId});
    },
    getViewport: () => ({imageId}) => {
      return this.viewportsByImageId[imageId] || null;
    },
    hasViewport: () => ({imageId}) => {
      return !!this.getters.getViewport({imageId});
    }
  };

  constructor (store) {
    this.__bindViewportEvents(store);
  }

  __bindViewportEvents ({uScopeApi, state, resources, dispatch}) {
    const self = this;

    // Any time uScope creates a viewport we should capture it so that it can be exposed to the Store's ecosystem
    uScopeApi.plugins.register({
      name: 'us:stores:viewport',

      extends: 'viewport',

      constructor (uScope, viewport) {
        self.viewportsByImageId[viewport.rawImageId] = viewport;

        // Remove the viewport when it's closed to prevent unexpected behaviors.
        viewport.events.on('$destroy', () => {
          self.viewportsByImageId[viewport.rawImageId] = null;
        });

        // The AFTER_VIEWPORT_CREATED event is used to allow services to add hooks to the viewport's event channel
        // or for access to services/extensions installed on it.
        dispatch('AFTER_VIEWPORT_CREATED', viewport);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/uScope/ViewportState.js